export const aboutData = {
  title: "About me",
  description1:
    "My name's Ramkumar. I'm a Team lead and Fullstack developer based in Madurai, Tamilnadu.",
  description2:
    "Im Passionate about the backend engineering, developer tooling; Love building high-quality products and experimenting with new tech, I work as a FullStack web developement about 11 years and focusing on develop new products, SaaS, mentor other developers then talk about tech. Right now I'm also trying a hand at VueJS and NodeJS. I love to learn and explore new arenas.",
  image: 1,
};
